import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';

@Injectable()
export class AuthService {
	user: Observable<firebase.User>;
	items: FirebaseListObservable<any[]>;
	constructor(private firebaseAuth: AngularFireAuth, public af: AngularFireAuth, db: AngularFireDatabase) { 
		this.user = af.authState;
		//localStorage.setItem('user', JSON.stringify(this.user));
		this.items = db.list('items');
		console.log(this.items);
		console.log(this.user);
	}
	loginWithGoogle() { 
		return this.af.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
	}

	login(email: string, password: string) {
		this.firebaseAuth.auth
			.signInWithEmailAndPassword(email, password)
			.then(value => {
				console.log('Nice, it worked!');
			})
			.catch(err => {
				console.log('Something went wrong:', err.message);
			});
	}

	logout() {
		return this.af.auth.signOut();
	}

	hasUserLoggedIn() {
		return localStorage.getItem('user');
	}

	getUserDetails() {
		return JSON.parse(localStorage.getItem('user'));
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/.providers/auth.service.ts